import { FaHome, FaTools } from 'react-icons/fa';
import {
	TbCircleLetterR,
	TbCircleLetterC,
	TbCircleLetterU,
	TbCircleLetterG,
	TbCircleLetterE,
	TbCircleLetterM,
	TbCircleLetterT,
	TbCircleLetterA,
	TbCircleLetterB,
	TbCircleLetterV,
	TbCircleLetterS,
	TbCircleLetterP,
	TbCircleLetterL,
} from 'react-icons/tb';
import { MdCategory } from "react-icons/md";

import { HiOutlineStatusOnline } from "react-icons/hi";

import { BiSolidDashboard } from 'react-icons/bi';
import { GiArchiveRegister } from "react-icons/gi";

import { VscGraph } from 'react-icons/vsc';

import { MdOutlineEditNote, MdOutlineEnergySavingsLeaf } from 'react-icons/md';
import { IoAirplane, IoDocumentText } from 'react-icons/io5';

import { TbUserPlus } from 'react-icons/tb';
import { ArrowLeft } from 'lucide-react';
import { FaRegRectangleList } from 'react-icons/fa6';

const sizeIcons = 'h-5 w-5 lg:h-6 lg:w-6';

export const publicPages = ['/login', '/recuperar-senha', '/reset-password'];

export const colorsPallete = [
	/* Cores com classe em globals.css */
	{
		class: 'amber500',
		tw: 'amber-500',
		color: '#f59e0b',
		borderClass: 'LBamber500',
	},
	{
		class: 'red700',
		tw: 'red-700',
		color: '#b91c1c',
		borderClass: 'LBred700',
	},
	{
		class: 'emerald600',
		tw: 'emerald-600',
		color: '#059669',
		borderClass: 'LBemerald600',
	},
	{
		class: 'orange600',
		tw: 'orange-600',
		color: '#ea580c',
		borderClass: 'LBorange600',
	},
	{
		class: 'pink600',
		tw: 'pink-600',
		color: '#86198f',
		borderClass: 'LBpink600',
	},
	{
		class: 'fuchsia800',
		tw: 'fuchsia-800',
		color: '#db2777',
		borderClass: 'LBfuchsia800',
	},
	/* {
		id: 7,
		class: 'amber500',
		tw: 'amber-500',
		color: '#f59e0b',
		borderClass: 'LBamber500',
	},
	{
		id: 8,
		class: 'red700',
		tw: 'red-700',
		color: '#b91c1c',
		borderClass: 'LBred700',
	},
	{
		id: 9,
		class: 'emerald600',
		tw: 'emerald-600',
		color: '#059669',
		borderClass: 'LBemerald600',
	},
	{
		id: 10,
		class: 'orange600',
		tw: 'orange-600',
		color: '#ea580c',
		borderClass: 'LBorange600',
	},
	{
		id: 11,
		class: 'pink600',
		tw: 'pink-600',
		color: '#86198f',
		borderClass: 'LBpink600',
	},
	{
		id: 12,
		class: 'fuchsia800',
		tw: 'fuchsia-800',
		color: '#db2777',
		borderClass: 'LBfuchsia800',
	}, */
];

export const SidebarData = [
	{
		_categoryId: 0,
		category: 'Unidade',
		items: [
			{
				title: 'Resumo',
				href: '/resumo-unidade',
				icon: <FaHome className={sizeIcons} />,
				submenu: true,
				submenuItems: [
					{
						title: 'Dashboard',
						href: '/item1',
					},
				],
			},
		],
	},
	{
		_categoryId: 1,
		category: 'Monitoramento',
		items: [
			{
				title: 'Geral',
				href: '/monitoramento/geral',
				icon: <BiSolidDashboard className={sizeIcons} />,
				submenu: true,
				submenuItems: [
					{
						title: 'Dashboard',
						href: '/item1',
					},
				],
			},
			{
				title: 'Energia',
				href: '/monitoramento/energia',
				icon: (
					<MdOutlineEnergySavingsLeaf
						className={sizeIcons}
					/>
				),
				submenu: false,
			},
			{
				title: 'Cargas Termicas',
				href: '/monitoramento/cargas-termicas',
				icon: <VscGraph className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Últimas Leituras',
				href: '/ultimas-leituras',
				icon: <MdOutlineEditNote  className={sizeIcons} />,
				permissions: ["ADMIN", "SUPER_USER"],
				submenu: false,
			},
			{
				title: 'Leituras',
				href: '/leituras',
				icon: <MdOutlineEditNote  className={sizeIcons} />,
				permissions: ["ADMIN", "SUPER_USER"],
				submenu: false,
			},
			{
				title: 'Equipamentos',
				href: '/equipamentos',
				icon: <HiOutlineStatusOnline  className={sizeIcons} />,
				submenu: false,
			},
		],
	},
	// {
	// 	_categoryId: 2,
	// 	category: 'Equipamentos',
	// 	items: [
	// 		{
	// 			title: 'Unidade',
	// 			href: '/equipamentos/unidade',
	// 			icon: <TbCircleLetterU className={sizeIcons} />,
	// 			submenu: false,
	// 		},
	// 		{
	// 			title: 'Regime',
	// 			href: '/equipamentos/regime',
	// 			icon: <TbCircleLetterR className={sizeIcons} />,
	// 			submenu: false,
	// 		},
	// 		{
	// 			title: 'Compressor',
	// 			href: '/equipamentos/compressor',
	// 			icon: <TbCircleLetterC className={sizeIcons} />,
	// 			submenu: false,
	// 		},
	// 		{
	// 			title: 'Condensador',
	// 			href: '/equipamentos/condensador',
	// 			icon: <TbCircleLetterC className={sizeIcons} />,
	// 			submenu: false,
	// 		},
	// 	],
	// },
	{
		_categoryId: 3,
		category: 'Relatorios',
		items: [
			{
				title: 'Ambientes',
				href: '/relatorio/ambiente',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Chillers',
				href: '/relatorio/chiller',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Compressores',
				href: '/relatorio/compressor',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Condensadores',
				href: '/relatorio/condensador',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Eventos',
				href: '/relatorio/evento',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Regimes',
				href: '/relatorio/regime',
				icon: <IoDocumentText  className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Produção',
				href: '/producao-diaria',
				icon: <FaRegRectangleList className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Produto',
				href: '/produto',
				icon: <MdCategory className={sizeIcons} />,
				submenu: false,
			},

			// {
			// 	title: 'Energia',
			// 	href: '/energia',
			// 	icon: (
			// 		<MdOutlineEnergySavingsLeaf
			// 			className={sizeIcons}
			// 		/>
			// 	),
			// 	submenu: false,
			// },
			// {
			// 	title: 'Alarmes',
			// 	href: '/Alarmes',
			// 	icon: <RiAlarmWarningFill className={sizeIcons} />,
			// 	submenu: false,
			// },
		],
	},
	{
		_categoryId: 4,
		category: 'Registros',
		items: [
			{
				title: 'Manutenção',
				href: '/manutencao',
				icon: <FaTools className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Diário de Operação',
				href: '/diario-operacao',
				icon: <GiArchiveRegister className={sizeIcons} />,
				submenu: false,
			},
		],
	},
	{
		_categoryId: 5,
		category: 'Simulação',
		items: [
			{
				title: 'Unidade',
				href: '/simulacao-unidade',
				icon: <IoAirplane className={sizeIcons} />,
				submenu: false,
			},
		],
	},
];

export const SidebarDataAdmin = [
	{
		_categoryId: 1,
		category: 'GERAL',
		items: [
			{
				title: 'Usuário',
				href: '/admin/usuario/1',
				icon: <TbUserPlus className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Grupo',
				href: '/admin/grupo/1',
				icon: <TbCircleLetterG className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Empresa',
				href: '/admin/empresa/1',
				icon: <TbCircleLetterE className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Unidade',
				href: '/admin/unidade/1',
				icon: <TbCircleLetterU className={sizeIcons} />,
				submenu: false,
			},
		],
	},
	{
		_categoryId: 2,
		category: 'UNIDADE',
		items: [
			{
				title: 'Marca',
				href: '/admin/marca/1',
				icon: <TbCircleLetterM className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Modelo',
				href: '/admin/modelo/1',
				icon: <TbCircleLetterM className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Modelo Compressor',
				href: '/admin/modeloCompressor/1',
				icon: <TbCircleLetterM className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Tipo Operação Compressor',
				href: '/admin/tipoOperacaoCompressor/1',
				icon: <TbCircleLetterT className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Unidade Detalhes',
				href: '/admin/unidade-detalhes',
				icon: <TbCircleLetterP className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Produto',
				href: '/admin/produto/1',
				icon: <TbCircleLetterP className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Regime',
				href: '/admin/regime/1',
				icon: <TbCircleLetterR className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Ar Comprimido',
				href: '/admin/ar-comprimido/1',
				icon: <TbCircleLetterA className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Linha Produção',
				href: '/admin/linha-producao/1',
				icon: <TbCircleLetterL className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Chiller',
				href: '/admin/chiller/1',
				icon: <TbCircleLetterC className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Condensação',
				href: '/admin/condensacao/1',
				icon: <TbCircleLetterC className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Máquina de Gelo',
				href: '/admin/maquina-gelo/1',
				icon: <TbCircleLetterM className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Sistema de água gelada',
				href: '/admin/sistema-agua-gelada/1',
				icon: <TbCircleLetterS className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Ambiente',
				href: '/admin/ambiente/1',
				icon: <TbCircleLetterA className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Evaporador',
				href: '/admin/evaporador/1',
				icon: <TbCircleLetterE className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Condensador',
				href: '/admin/condensador/1',
				icon: <TbCircleLetterC className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Bomba',
				href: '/admin/bomba/1',
				icon: <TbCircleLetterB className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Bomba de Vácuo',
				href: '/admin/bomba-vacuo/1',
				icon: <TbCircleLetterB className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Ventilador',
				href: '/admin/ventilador/1',
				icon: <TbCircleLetterV className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Compressor',
				href: '/admin/compressor/1',
				icon: <TbCircleLetterC className={sizeIcons} />,
				submenu: false,
			},
			{
				title: 'Voltar',
				href: '/escolha-unidade',
				icon: <ArrowLeft className={sizeIcons} />,
				submenu: false,
			},
		]
	}
];

export const tipoOperacaoCompressor = [
	{
		id: 1,
		nome: 'BOOSTER',
	},
	{
		id: 2,
		nome: 'COMPRESSAO_UNICA',
	},
	{
		id: 3,
		nome: 'ALTA',
	},
];

export const delayTime = 2000;


export const accessTokenKeyName = "xjwt_zp3r"
export const refreshTokenKeyName = "refreshToken"
export const unidadeIdKeyName = "unId"
export const unitAccessTokenKeyName = "ujwt_zp3r"
export const unitRefreshToken = "UnitRefreshToken"


export const routeTitles = [
	{ path: "/", title: "Início" },
	{ path: "/login", title: "Login" },
	{ path: "/recuperar-senha", title: "Recuperar Senha" },
	{ path: "/diario-operacao", title: "Diário de Operação" },
	{ path: "/manutencao", title: "Manutenção" },
	{ path: "/reset-password", title: "Redefinir Senha" },
	{ path: "/suporte", title: "Suporte" },
	{ path: "/resumo-unidade", title: "Resumo da Unidade" },
	{ path: "/escolha-unidade", title: "Escolha da Unidade" },
	{ path: "/monitoramento/geral", title: "Monitoramento Geral" },
	{ path: "/simulacao-unidade", title: "Simulação da Unidade" },
	{ path: "/monitoramento/energia", title: "Monitoramento de Energia" },
	{ path: "/monitoramento/cargas-termicas", title: "Cargas Térmicas" },
	{ path: "/producao-diaria", title: "Produção Diária" },
	{ path: "/relatorio/ambiente", title: "Relatório de Ambiente" },
	{ path: "/relatorio/chiller", title: "Relatório de Chiller" },
	{ path: "/relatorio/compressor", title: "Relatório de Compressor" },
	{ path: "/relatorio/condensador", title: "Relatório de Condensador" },
	{ path: "/relatorio/evento", title: "Relatório de Evento" },
	{ path: "/relatorio/regime", title: "Relatório de Regime" },
	{ path: "/ultimas-leituras", title: "Últimas Leituras" },
	{ path: "/leituras", title: "Leituras" },
	{ path: "/produto", title: "Produto" },
	{ path: "/admin", title: "Painel Administrativo" },
	{ path: "/admin/usuario/:page", title: "Gerenciar Usuários" },
	{ path: "/admin/grupo/:page", title: "Gerenciar Grupos" },
	{ path: "/admin/empresa/:page", title: "Gerenciar Empresas" },
	{ path: "/admin/unidade/:page", title: "Gerenciar Unidades" },
	{ path: "/admin/chiller/:page", title: "Gerenciar Chillers" },
	{ path: "/admin/regime/:page", title: "Gerenciar Regimes" },
	{ path: "/admin/maquina-gelo/:page", title: "Gerenciar Máquinas de Gelo" },
	{
	  path: "/admin/sistema-agua-gelada/:page",
	  title: "Gerenciar Sistemas de Água",
	},
	{ path: "/admin/ambiente/:page", title: "Gerenciar Ambientes" },
	{ path: "/admin/ar-comprimido/:page", title: "Gerenciar Ar Comprimido" },
	{ path: "/admin/evaporador/:page", title: "Gerenciar Evaporadores" },
	{ path: "/admin/condensacao/:page", title: "Gerenciar Condensação" },
	{ path: "/admin/marca/:page", title: "Gerenciar Marcas" },
	{ path: "/equipamentos", title: "Equipamentos" },
	{ path: "/admin/modelo/:page", title: "Gerenciar Modelos" },
	{ path: "/admin/condensador/:page", title: "Gerenciar Condensadores" },
	{ path: "/admin/bomba/:page", title: "Gerenciar Bombas" },
	{ path: "/admin/bomba-vacuo/:page", title: "Gerenciar Bombas de Vácuo" },
	{ path: "/admin/linha-producao/:page", title: "Gerenciar Linhas Produção" },
	{ path: "/admin/ventilador/:page", title: "Gerenciar Ventiladores" },
	{ path: "/admin/produto/:page", title: "Gerenciar Produtos" },
	{ path: "/admin/compressor/:page", title: "Gerenciar Compressores" },
	{
	  path: "/admin/modeloCompressor/:page",
	  title: "Gerenciar Modelos de Compressor",
	},
	{
	  path: "/admin/tipoOperacaoCompressor/:page",
	  title: "Gerenciar Tipos de Operação",
	},
  ];